import React from "react";
import { fetchData, URL_WIS2GTSTEMP_AGGREGATED_OBSERVATIONS_POPUP } from "../../../utils/api";
import LinkOSCAR from "../LinkOSCAR/LinkOSCAR";
import { buildTempDataTable } from "./popupUtils";

export function fetchWis2gtstempPopupInfo(
  props,
  periodsAsQP,
  linkTimeSeries,
  setContent
) {
  let url = `${URL_WIS2GTSTEMP_AGGREGATED_OBSERVATIONS_POPUP}/?baseline=${props.baseline}&period_type=${props.selectedPeriodType}&report=${props.selectedReport}&station_id=${props.stationObject.station_id}&${periodsAsQP}&var_id=${props.selectedVariable}`;
  fetchData(url).then(response => {
    if (response.data.length > 0) {
      let labelID = "WSI";

      props.onSetSelectedStation({
        name: response.data[0].station,
        wigosid: response.data[0].wigosid,
        nr_received: response.data[0].nr_received,
        timeliness: response.data[0].timeliness,
        center: response.data[0].center
      });
      let part1;
      if (props.selectedReport === "wis2live") {
        part1 = [
          `Name: ${response.data[0].station}`,
          `${labelID}: ${response.data[0].wigosid}`,
          `Received: ${response.data[0].nr_received}`,
          `Center: ${response.data[0].center}`,
          `Source: ${response.data[0].source}`,
          `Encoding: ${response.data[0].encoding}`,
          `Topic Center: ${response.data[0].topic_center}`
        ];
      } else if (props.selectedReport === "gts-to-wis2") {
        part1 = [
          `Name: ${response.data[0].station}`,
          `${labelID}: ${response.data[0].wigosid}`,
          `Center: ${response.data[0].center}`,
          `Source: ${response.data[0].source}`,
          `Topic Center: ${response.data[0].topic_center}`
        ];
      } else if (props.selectedReport === "tac-to-bufr") {
        part1 = [
          `Name: ${response.data[0].station}`,
          `${labelID}: ${response.data[0].wigosid}`,
          `Center: ${response.data[0].center}`,
          `Source: ${response.data[0].source}`,
          `Encoding: ${response.data[0].encoding}`,
          `Topic Center: ${response.data[0].topic_center}`,
          `Bufr Nr Received: ${response.data[0].bufr_nr_received}`,
          `TAC Nr Received: ${response.data[0].tac_nr_received}`
        ];
      } else if (props.selectedReport === "bufr_oscar_coords") {
        part1 = [
          `Name: ${response.data[0].station}`,
          `${labelID}: ${response.data[0].wigosid}`,
          `Received: ${response.data[0].nr_received}`,
          `Center: ${response.data[0].center}`,
          `Source: ${response.data[0].source}`,
          `Max distance: ${response.data[0].distance_diff}`,
          `Obs latitude: ${response.data[0].obs_latitude}`,
          `Obs longitude: ${response.data[0].obs_longitude}`,
          `Oscar latitude: ${response.data[0].oscar_latitude}`,
          `Oscar longitude: ${response.data[0].oscar_longitude}`
        ];
      }

      let dataTable = null;
      if (props.selectedReport === "gts-to-wis2") {
        dataTable = buildTempDataTable(response.data[0]);
      }

      const htmlPart1 = part1.map(v => {
        return <li key={v}>{v}</li>;
      });

      const htmlContent = (
        <>
          <span>{/* <b>GTSWIS2TEMP</b> */}</span>
          {htmlPart1}
          {dataTable}
        </>
      );

      let linkOSCAR;

      let links = linkTimeSeries;

      linkOSCAR = (
        <>
          <LinkOSCAR wigosid={response.data[0].wigosid} />
        </>
      );
      if (!response.data[0].in_oscar) {
        linkOSCAR = (
          <a
            className="isDisabled link-oscar"
            target="_blank"
            rel="noopener noreferrer"
            href="#"
            onClick={e => e.preventDefault()}
          >
            Open in OSCAR
          </a>
        );
      }
      links = (
        <>
          {linkTimeSeries}
          <br />
          <hr />
          {/* {linkOSCAR} */}
        </>
      );

      setContent(
        <ul className="popup-station-properties">
          {htmlContent}
          {links}
        </ul>
      );
    }
  });
}
